import type Rollbar from 'rollbar';
import getEnv, { Environment, Host } from '@/utils/environment';

const env = getEnv();

interface RollbarItem extends Rollbar.Dictionary {
  body?: {
    message?: {
      body?: string;
      [key: string]: unknown;
    };
    trace?: {
      exception?: {
        message?: string;
        [key: string]: unknown;
      };
    };
    trace_chain?: Array<{
      exception?: {
        message?: string;
        [key: string]: unknown;
      };
    }>;
    [key: string]: unknown;
  };
}

const checkIgnore: Rollbar.Configuration['checkIgnore'] = (
  isUncaught,
  _args,
  item: RollbarItem
): boolean => {
  if (isUncaught) {
    const errorMessage =
      item.body?.message?.body ??
      item.body?.trace?.exception?.message ??
      item.body?.trace_chain?.[0]?.exception?.message;

    if (errorMessage?.includes('ChunkLoadError')) {
      console.warn('Ignoring ChunkLoadError:', errorMessage);
      return true;
    }
  }

  return false;
};

export const rollbarConfig: Rollbar.Configuration = {
  hostSafeList: Object.values(Host),
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: env !== Environment.LOCAL,
  payload: {
    environment: env,
    client: {
      javascript: {
        guess_uncaught_frames: true,
        source_map_enabled: true,
        code_version: process.env.NEXT_PUBLIC_GIT_HASH,
      },
    },
  },
  checkIgnore,
};
